module.exports = __webpack_public_path__ + "img/SHELL.ebcb3bb3.jpg";